"use strict";

class SalesIndexController {

  constructor($scope, $window, SSUserService, SSAppService, SSHttpService, SSUtilService, SSDateService, SSAlertService, SSAnalyticsService) {
    const self = this;

    //constants
    self.OFFER_NEW = 1;
    self.OFFER_APPROVE = 2;
    self.OFFER_REJECT = 3;

    self.$scope = $scope;
    self.$window = $window;

    self.SSUserService = SSUserService;
    self.SSUtilService = SSUtilService;
    self.SSHttpService = SSHttpService;
    self.SSDateService = SSDateService;
    self.SSAppService = SSAppService;
    self.SSAlertService = SSAlertService;
    self.SSAnalyticsService = SSAnalyticsService;

    self.SALE_STATUS_VERIFIED = SHOWSUITE.SALE_STATUS_VERIFIED;
    self.SALE_STATUS_APPROVED = SHOWSUITE.SALE_STATUS_APPROVED;
    self.SALE_STATUS_REJECTED = SHOWSUITE.SALE_STATUS_REJECTED;
    self.SALE_STATUS_OTP = SHOWSUITE.SALE_STATUS_OTP;

    if (self.SSUserService.isDeveloper()) {
        self.init();
    }

    // ctrl.propertyFilter = SHOWSUITE.propertyFilter;
    // ctrl.developerPropertyURL = SHOWSUITE.salesViewData.routes['developerProperties'];//'/developer/property';
    // ctrl.developerSaleURL = SHOWSUITE.salesViewData.routes['developerSales']; //'developer/sale';

    // ctrl.displayYear = false;
    // ctrl.displayMonth = false;
    // ctrl.displayWeek = false;
    // ctrl.displayDate = false;

    // ctrl.refreshSumData();

    // ctrl.yearOptionsFromCalendar = ctrl.SSDateService.getFormatOptionForYear();
    // ctrl.monthOptionsFromCalendar = ctrl.SSDateService.getFormatOptionForMonth();

    // //pagination related variables
    // ctrl.currentPage = 0;
    // ctrl.loadingIndicator = false;
    // ctrl.count = SHOWSUITE.salesViewData.offersData['count'];
    // ctrl.limit = SHOWSUITE.salesViewData.offersData['limit'];
    // ctrl.updateTotalPageCount();

    // //method to prepare view data 
    // ctrl.prepareViewData(SHOWSUITE.salesViewData.offersData);
    // ctrl.onChangeDate();
    // ctrl.onChangeWeek();
    // ctrl.onChangeMonth();
    // ctrl.onChangeYear();
  }

  init() {
    const self = this;

      // Trigger View Event for Sales Page
      self.SSAnalyticsService.saveAnalyticEvent({
              event: self.SSAnalyticsService.ANALYTICS_EVENT_VIEWS_DMS_SALES,
              user_id: self.SSUtilService.getFromLocalStorage('user').id
          }
      );

    self.sales_count = 0;
    self.payments_count = 0;

    self.retrieveApplications();
   // self.retrievePayments();
  }

  retrieveApplications() {
    const self = this;

    let url = 'sec/developer/sales';
    let params = {
        'send_total_count': true,
        'status': self.SALE_STATUS_VERIFIED,
        'offset' : 0,
        'limit' : 5000,
        'include' : 'payments'
    };

    self.totalPayments = null;

    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
        if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
        }

        self.salesDetails = response.data.sales;
        self.sales_count = response.data.total_count;
        // As per Taiyab Feedback currently we comment out this code to hide the sales count
        /*jQuery.each(self.salesDetails, function (index, sales) {
            self.totalPayments += sales.payments.length;
        });*/
    });
  }

  retrievePayments() {
    const self = this;

    let url = 'sec/developer/payments';
    let params = {
      'send_total_count': true
    };

    self.SSHttpService.getAPIRequest(url, params).then(function (response) {
        if (response instanceof Error) {
            self.SSAlertService.parseAndDisplayError(response);
            return;
        }

        self.payments_count = response.data.count;
    });
  }

  refreshSumData() {
    const ctrl = this;

    ctrl.nowDate = moment();
    ctrl.selectedDate = moment(ctrl.nowDate).format('YYYY-MM-DD');
    ctrl.selectedWeek = moment(ctrl.nowDate).isoWeek();
    ctrl.selectedMonth = moment(ctrl.nowDate).format('MMMM \'YY');
    ctrl.selectedYear = moment(ctrl.nowDate).year();

    ctrl.previousDate = moment(ctrl.nowDate).subtract(1, 'days').format('YYYY-MM-DD');
    ctrl.previousWeek = moment(ctrl.nowDate).subtract(1, 'weeks').isoWeek();
    ctrl.previousMonth = moment(ctrl.nowDate).subtract(1, 'months').format('MMMM \'YY');
    ctrl.previousYear = moment(ctrl.nowDate).subtract(1, 'years').year();

    ctrl.sumByDate = null;
    ctrl.sumByWeek = null;
    ctrl.sumByMonth = null;
    ctrl.sumByYear = null;
    ctrl.sumByPreviousDate = null;
    ctrl.sumByPreviousWeek = null;
    ctrl.sumByPreviousMonth = null;
    ctrl.sumByPreviousYear = null;

    ctrl.progressSumByDate = false;
    ctrl.progressSumByMonth = false;
    ctrl.progressSumByYear = false;

  }
  onChangeDate() {

    const ctrl = this;

    ctrl.progressSumByDate = true;
    ctrl.SSHttpService.getAPIRequest('sec/developer/statistics/sales-sum-for-day').then(
      function (responseObj) {
        ctrl.progressSumByDate = false;
        if (responseObj instanceof Error) {
          ctrl.SSUtilService.logError("Error fetching Result: " + responseObj.toString());
          return;
        }

        if(_.has(responseObj, 'data.sum')) {
          ctrl.sumByDate = responseObj.data.sum;
          ctrl.sumByPreviousDate = responseObj.data.prvSum;
        }

      }
    );
  }

  onChangeWeek() {

    const ctrl = this;

    ctrl.progressSumByWeek = true;
    ctrl.SSHttpService.getAPIRequest('sec/developer/statistics/sales-sum-for-week').then(
      function (responseObj) {
        ctrl.progressSumByWeek = false;
        if (responseObj instanceof Error) {
          ctrl.SSUtilService.logError("Error fetching Result: " + responseObj.toString());
          return;
        }

        if(_.has(responseObj, 'data.sum')) {
          ctrl.sumByWeek = responseObj.data.sum;
          ctrl.sumByPreviousWeek = responseObj.data.prvSum;
        }

      }
    );
  }

  onChangeMonth() {

    const ctrl = this;

    ctrl.progressSumByMonth = true;
    ctrl.SSHttpService.getAPIRequest('sec/developer/statistics/sales-sum-for-month').then(
      function (responseObj) {
        ctrl.progressSumByMonth = false;
        if (responseObj instanceof Error) {
          ctrl.SSUtilService.logError("Error fetching Result: " + responseObj.toString());
          return;
        }

        if(_.has(responseObj, 'data.sum')) {
          ctrl.sumByMonth = responseObj.data.sum;
          ctrl.sumByPreviousMonth = responseObj.data.prvSum;
        }

      }
    );
  }

  onChangeYear() {

    const ctrl = this;

    ctrl.progressSumByYear = true;
    ctrl.SSHttpService.getAPIRequest('sec/developer/statistics/sales-sum-for-year').then(
      function (responseObj) {
        ctrl.progressSumByYear = false;
        if (responseObj instanceof Error) {
          ctrl.SSUtilService.logError("Error fetching Result: " + responseObj.toString());
          return;
        }

        if(_.has(responseObj, 'data.sum')) {
          ctrl.sumByYear = responseObj.data.sum;
          ctrl.sumByPreviousYear = responseObj.data.prvSum;
        }

      }
    );
  }

  prepareViewData(offersData) {
    const ctrl = this;

    ctrl.offers = offersData.offers;
    ctrl.usersMap = offersData.users_map;
    ctrl.unitsMap = offersData.units_map;
    ctrl.propertiesMap = offersData.properties_map;

    //we are not using users map here because the view doesn't need it now. But we are leaving it here for future use.
    let prvUnitId = null;
    _.forEach(
      ctrl.offers, function (offer) {
        const unit = ctrl.unitsMap[offer.unit_id];
        const property = ctrl.propertiesMap[unit.property_id];
        if(prvUnitId != unit.id ) {
          prvUnitId = unit.id;
          offer.unitType = unit.rooms + " Rooms, " + unit.baths + " Baths " + "(" + unit.type + ")";  //to do unit types
          offer.propertyId = property.id;
          offer.projectName = property.name;
          offer.unitNo = "S:" + unit.stack_id + " F:" + ctrl.SSUtilService.getUnitNumberStr(unit.floor_no) + " U:" + ctrl.SSUtilService.getUnitNumberStr(unit.unit_no);
          offer.salePrice = unit.price;
        } else {
          offer.unitType = "-";
          offer.propertyId = "-";
          offer.projectName = "-";
          offer.unitNo = "-";
          offer.salePrice = "-";

        }

        offer.offerPrice = offer.amount;
        offer.offerPriceDiff = offer.amount - unit.price;  //should be negative value, but in case of bidding will be positive value
        offer.propertyURI = ctrl.getPropertyURI(offer.propertyId);
      }
    )
  }

  getPropertyURI(propertyId) {
    return [this.developerPropertyURL, propertyId].join("/");
  }

  approveOffer(offer) {
    const ctrl = this;
    ctrl.loadingIndicator = true;
    offer.loadingIndicator = true;

    let offerId = offer.id;
    let unitId = offer.unit_id;

    _.forEach(ctrl.offers, function(o) { //remove all other offers with same unit id.
      if (offerId != o.id && unitId == o.unit_id) {
        o.loadingIndicator = true;
      }
    });

    let uri = `sec/developer/offers/${offer.id}/approve`;
    ctrl.SSHttpService.postAPIRequest(uri).then(
      function (responseObj) {
        ctrl.loadingIndicator = false;
        offer.loadingIndicator = false;
        if (responseObj instanceof Error) {
          ctrl.SSUtilService.logError("Error fetching Result: " + responseObj.toString());
          _.forEach(ctrl.offers, function(o) { //remove all other offers with same unit id.
            if (offerId != o.id && unitId == o.unit_id) {
              o.loadingIndicator = false;
            }
          });

          return;
        }


        offer.status = ctrl.OFFER_APPROVE;

        _.forEach(ctrl.offers, function(o) { //remove all other offers with same unit id.
          if (offerId != o.id && unitId == o.unit_id) {
            o.loadingIndicator = false;
            o.status = ctrl.OFFER_REJECT;
          }
        });

      }
    );
  }

  rejectOffer(offer) {
    const ctrl = this;
    ctrl.loadingIndicator = true;
    offer.loadingIndicator = true;
    let uri = `sec/developer/offers/${offer.id}/reject`;
    ctrl.SSHttpService.postAPIRequest(uri).then(
      function (responseObj) {
        ctrl.loadingIndicator = false;
        offer.loadingIndicator = false;
        if (responseObj instanceof Error) {
          ctrl.SSUtilService.logError("Error fetching Result: " + responseObj.toString());
          return;
        }

        offer.status = ctrl.OFFER_REJECT;
        //var index = ctrl.offers.indexOf(offer);
        //ctrl.offers = ctrl.offers.splice(index, 1).OFFER_REJECT;
      }
    );
  }

  nextPage(jump) {
    const ctrl = this;
    if (!jump) {
      jump = 1;
    }

    if ((ctrl.currentPage * ctrl.limit) < ctrl.count) {
      ctrl.fetchPage(ctrl.currentPage + 1);
    }
  }

  previousPage(jump) {
    const ctrl = this;
    if (!jump) {
      jump = 1;
    }
    if (ctrl.currentPage > 0) {
      ctrl.fetchPage(ctrl.currentPage - 1);
    }
  }

  updateTotalPageCount() {
    const ctrl = this;
    ctrl.totalPages = (ctrl.limit == 0) ? 1 : Math.ceil(ctrl.count / ctrl.limit);
  }

  fetchPage(pageNumber) {
    const ctrl = this;
    ctrl.loadingIndicator = true;

    let params = `?offset=${ pageNumber * ctrl.limit}&limit=${ctrl.limit}&sendCount=false`;
    if (ctrl.propertyFilter != null && ctrl.propertyFilter.length > 0) {
      params += '&property_filter=' + ctrl.propertyFilter;
    }
    let uri = ctrl.developerSaleURL + params;

    ctrl.SSHttpService.getRequest(uri).then(
      function (responseObj) {
        ctrl.loadingIndicator = false;

        if (responseObj instanceof Error) {
          ctrl.SSUtilService.logError("Error fetching Result: " + responseObj.toString());
          return;
        }

        let viewData = responseObj.data.viewData;
        let offersData = viewData.offersData;
        if (offersData) {
          if (offersData.hasOwnProperty('offers')) {
            ctrl.prepareViewData(offersData);
            ctrl.currentPage = pageNumber;
          } else {
            ctrl.SSUtilService.logError("Error fetching Result: " + offersData);
          }

          if (offersData.hasOwnProperty('count')) {
            ctrl.count = offersData['count'];
          }

          if (offersData.hasOwnProperty('limit')) {
            ctrl.limit = offersData['limit'];
          }

          if (offersData.hasOwnProperty('offset')) {
            ctrl.currentPage = offersData['offset'] / offersData['limit'];
          }

          ctrl.updateTotalPageCount();
        }
      }
    );
  }

  toggleDisplayYear() {
    this.displayYear = !this.displayYear;
  }

  toggleDisplayDate() {
    this.displayDate = !this.displayDate;
  }

  toggleDisplayMonth() {
    this.displayMonth = !this.displayMonth;
  }

  viewCustomerDetails(offer) {
    const ctrl = this;
    //console.log(offer);
    ctrl.$window.location.href = "/folio/investments/"+offer.sale_id;
  }

}

SalesIndexController.$inject = ['$scope', '$window', 'SSUserService', 'SSAppService', 'SSHttpService', 'SSUtilService', 'SSDateService', 'SSAlertService', 'SSAnalyticsService'];
app.controller('SalesIndexController', SalesIndexController);